<template>
  <div class="menu-profile">
    <div class="menu-body">
      <table class="table-property">
        <tbody>
          <tr>
            <th>{{ $t('models.user.attributes.isRecieveEmail') }}</th>
            <td>{{ user.meta.isRecieveEmail ? $t('models.user.isRecieveEmailStatus.on') : $t('models.user.isRecieveEmailStatus.off') }}</td>
          </tr>
          <tr>
            <th>{{ $t('models.user.attributes.isUseNotification') }}</th>
            <td>{{ user.meta.isUseNotification ? $t('models.user.isUseNotification.on') : $t('models.user.isUseNotification.off') }}</td>
          </tr>
          <tr v-if="!isNotificationPermissionConsist()">
            <th></th>
            <td class="text-error">{{ $t('common.notificationPermission') }}</td>
          </tr>
          <tr>
            <th>{{ $t('models.user.attributes.isShareEmail') }}</th>
            <td>{{ user.meta.isShareEmail ? $t('models.user.isShareStatus.on') : $t('models.user.isShareStatus.off') }}</td>
          </tr>
          <tr>
            <th>{{ $t('models.user.attributes.isSharePhone') }}</th>
            <td>{{ user.meta.isSharePhone ? $t('models.user.isShareStatus.on') : $t('models.user.isShareStatus.off') }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="menu-footer">
      <proa-button @click.native="toggleEditPersonalSettingsModal(true)">
        {{ $t('common.editPersonalSettings') }}
      </proa-button>
    </div>
    <proa-modal
      :modal="editPersonalSettingsModal"
      :title="$t('common.modals.editPersonalSettingsModal.title')"
      @close="toggleEditPersonalSettingsModal(false)"
    >
      <proa-input-group :label="$t('models.user.attributes.isRecieveEmail')">
        <template slot="input">
          <proa-radio-button
            :checked="editUser.userPropertyAttributes.isRecieveEmail"
            :disabled="editPersonalSettingsDisabled"
            @change="editUser.userPropertyAttributes.isRecieveEmail = true"
            class="mr-3"
          >
            <span>{{ $t('models.user.isRecieveEmailStatus.on') }}</span>
          </proa-radio-button>
          <proa-radio-button
            :checked="!editUser.userPropertyAttributes.isRecieveEmail"
            :disabled="editPersonalSettingsDisabled"
            @change="editUser.userPropertyAttributes.isRecieveEmail = false"
          >
            <span>{{ $t('models.user.isRecieveEmailStatus.off') }}</span>
          </proa-radio-button>
        </template>
      </proa-input-group>
      <proa-input-group :label="$t('models.user.attributes.isUseNotification')">
        <template slot="input">
          <proa-radio-button
            :checked="editUser.userPropertyAttributes.isUseNotification"
            :disabled="editPersonalSettingsDisabled"
            @change="onUseNotifyChange(true)"
            class="mr-3"
          >
            <span>{{ $t('models.user.isUseNotification.on') }}</span>
          </proa-radio-button>
          <proa-radio-button
            :checked="!editUser.userPropertyAttributes.isUseNotification"
            :disabled="editPersonalSettingsDisabled"
            @change="onUseNotifyChange(false)"
          >
            <span>{{ $t('models.user.isUseNotification.off') }}</span>
          </proa-radio-button>
          <div v-if="!isNotificationPermissionConsist()" class="mb-3 text-error">{{ $t('common.notificationPermission') }}</div>
        </template>
      </proa-input-group>
      <proa-input-group :label="$t('models.user.attributes.isShareEmail')">
        <template slot="input">
          <proa-radio-button
            :checked="editUser.userPropertyAttributes.isShareEmail"
            :disabled="editPersonalSettingsDisabled"
            @change="editUser.userPropertyAttributes.isShareEmail = true"
            class="mr-3"
          >
            <span>{{ $t('models.user.isShareStatus.on') }}</span>
          </proa-radio-button>
          <proa-radio-button
            :checked="!editUser.userPropertyAttributes.isShareEmail"
            :disabled="editPersonalSettingsDisabled"
            @change="editUser.userPropertyAttributes.isShareEmail = false"
          >
            <span>{{ $t('models.user.isShareStatus.off') }}</span>
          </proa-radio-button>
        </template>
      </proa-input-group>
      <proa-input-group :label="$t('models.user.attributes.isSharePhone')">
        <template slot="input">
          <proa-radio-button
            :checked="editUser.userPropertyAttributes.isSharePhone"
            :disabled="editPersonalSettingsDisabled"
            @change="editUser.userPropertyAttributes.isSharePhone = true"
            class="mr-3"
          >
            <span>{{ $t('models.user.isShareStatus.on') }}</span>
          </proa-radio-button>
          <proa-radio-button
            :checked="!editUser.userPropertyAttributes.isSharePhone"
            :disabled="editPersonalSettingsDisabled"
            @change="editUser.userPropertyAttributes.isSharePhone = false"
          >
            <span>{{ $t('models.user.isShareStatus.off') }}</span>
          </proa-radio-button>
        </template>
      </proa-input-group>
      <template slot="footer">
        <proa-button
          :disabled="editPersonalSettingsDisabled"
          @click.native="toggleEditPersonalSettingsModal(false)"
          class="mr-2"
        >
          {{ $t('common.cancel') }}
        </proa-button>
        <proa-button
          :loading="editPersonalSettingsDisabled"
          @click.native="$emit('onClickUpdateUserSettings', editUser)"
          variant="primary"
        >
          {{ $t('common.change') }}
        </proa-button>
      </template>
    </proa-modal>
  </div>
</template>

<script>
import Push from 'push.js'

export default {
  name: 'MemberProfileTabMenuPersonalSettings',
  props: {
    user: {
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      editPersonalSettingsDisabled: false,
      editPersonalSettingsModal: false,
      editUser: null
    }
  },
  methods: {
    setEditUserAttributes: function() {
      this.editUser = {
        userPropertyAttributes: {
          isRecieveEmail: this.user.meta.isRecieveEmail,
          isShareEmail: this.user.meta.isShareEmail,
          isSharePhone: this.user.meta.isSharePhone,
          isUseNotification: this.user.meta.isUseNotification
        }
      }
    },
    toggleEditPersonalSettingsModal(toggle) {
      if (toggle) {
        this.setEditUserAttributes()
      }
      this.editPersonalSettingsModal = toggle
    },
    onUseNotifyChange(toggle) {
      this.editUser.userPropertyAttributes.isUseNotification = toggle
      if (toggle) {
        //デスクトップ通知使用
        if (!Push.Permission.has()) {
          Push.Permission.request(this.onGrantNotificataionPermission,this.onDenyNotificataionPermission)
        }
      }
    },
    isNotificationPermissionConsist() {
      if (this.editUser.userPropertyAttributes.isUseNotification && !Push.Permission.has()) {
        return false
      } else {
        return true
      }
    },
    async onGrantNotificataionPermission() {

    },
    async onDenyNotificataionPermission() {

    }
  },
  created() {
    this.setEditUserAttributes()
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.menu-profile {
  height: 100%;
  display: flex;
  flex-direction: column;

  .menu-body {
    flex-grow: 1;
    padding: 20px;

    .table-property {
      margin-bottom: 25px;

      th, td {
        padding: 0 15px 10px 0;
        font-size: 15px;

        @include mq(md) {
          padding: 0 17px 15px 0;
          font-size: 14px;
        }
      }

      th {
        font-weight: 100;
        color: $secondary-color;
        min-width: 75px;

        @include mq(md) {
          font-weight: 600;
          color: #000;
          min-width: 73px;
        }
      }
    }
  }

  .menu-footer {
    display: flex;
    justify-content: center;
    padding: 20px;
    border-top: 1px solid $dark-border-color;

    @include mq(md) {
      justify-content: flex-end;
    }
  }
}
</style>
